import type { RadioGroupProps } from './RadioGroup';

export const DEFAULT_PROPS = {
  size: 'md',
  direction: 'column',
} as const satisfies Omit<RadioGroupProps, 'children'>;
